"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
var Options_1 = require("./Options");
function validateUtil(info, key, value) {
    if (info.eval) {
        var evalResult = info.eval(value);
        if (!evalResult.valid) {
            throw Error(evalResult.errorMsg);
        }
    }
    else if (info.type) {
        if (info.type === String) {
            if (typeof value !== 'string') {
                throw Error("'".concat(key, "' is not a string"));
            }
            if (info.required && value.length === 0) {
                throw Error("'".concat(key, "' is empty'"));
            }
        }
        else if (info.type === Number) {
            if (typeof value !== 'number') {
                throw Error("'".concat(key, "' is not a number"));
            }
        }
        else if (info.type === Boolean) {
            if (typeof value !== 'boolean') {
                throw Error("'".concat(key, "' is not a boolean"));
            }
        }
        else if (info.type === Object) {
            if (typeof value !== 'object') {
                throw Error("'".concat(key, "' is not a dictionary"));
            }
            if (info.required && Object.keys(value).length === 0) {
                throw Error("'".concat(key, "' is empty"));
            }
        }
        else if (info.type === Function) {
            if (typeof value !== 'function') {
                throw Error("'".concat(key, "' is not a function"));
            }
        }
    }
    else {
        throw new Error('invalid schema');
    }
}
function validateSingleOption(key, value, spec) {
    if (typeof spec[key] === 'undefined') {
        // ignore unknown keys
        return;
    }
    var info = spec[key];
    if (info.required && (typeof value === 'undefined' || value === null)) {
        throw Error("'".concat(key, "' is missing"));
    }
    if (!info.required && typeof value === 'undefined') {
        return;
    }
    if (Array.isArray(info.type)) {
        if (typeof value !== 'object' || !Array.isArray(value)) {
            throw Error("'".concat(key, "' is not an array"));
        }
        value.forEach(function (i) { return validateUtil(info, key, i); });
        return;
    }
    validateUtil(info, key, value);
}
function validate(options, spec) {
    if (spec === void 0) { spec = Options_1.AutocompleteOptions; }
    if (typeof options.type === 'undefined') {
        throw new Error('Type is not assigned.');
    }
    Object.entries(spec)
        .filter(function (_a) {
        var v = _a[1];
        return v.required &&
            (v.onlyForTypes ? v.onlyForTypes.includes(options.type) : true) &&
            (v.notForTypes ? !v.notForTypes.includes(options.type) : true);
    })
        .forEach(function (_a) {
        var k = _a[0];
        if (typeof options[k] === 'undefined') {
            throw new Error("Missing required option '".concat(k, "'."));
        }
    });
    Object.entries(options).forEach(function (_a) {
        var k = _a[0], v = _a[1];
        return validateSingleOption(k, v, spec);
    });
}
exports.validate = validate;
//# sourceMappingURL=data:application/json;base64,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